import { isoZ, z } from 'my-zod'
import { orderPaymentSchema, orderRefundSchema } from './order-payment'
import { RideInsuranceConfigSchemas } from '../../finance/ride-insurance-config'

export const rescheduleCustomerOrderSchema = z.object({
  customerOrderShortId: z.string(),
  reservation: z.object({
    productId: z.string(),
    beginDate: isoZ.date(),
    endDate: isoZ.date(),
    ridingStartTime: isoZ.time(),
    ridingEndTime: isoZ.time(),
    vehicles: z
      .object({
        assetFamilyId: z.string(),
        id: z.string(),
        pricingOverride: z.number().int().nonnegative().nullable(),
        quotedDate: isoZ.instant(),
        quotedDateLocal: isoZ.date(),
        quotedTimeLocal: isoZ.time(),
        numberOfUnitsAvailable: z.number().int().nonnegative(),
        /** signature is required for new vehicles or vehicle whole asset family is changing (effectively a new vehicle...) */
        /** nullish instead of nullable so reservation vehicle model can be passed in */
        signature: z.string().min(1).nullish()
      })
      .array()
      .min(1)
  }),
  orderTotalEstimate: z.number().nullable(),
  newPromotionDiscounts: z
    .object({
      promotion: z.object({
        id: z.string(),
        versionId: z.number(),
        code: z.string().nullable()
      }),
      discountId: z.string()
    })
    .array(),
  cancellationFee: z
    .object({
      amount: z.number(),
      id: z.string().uuid()
    })
    .nullable(),
  /** this is the amount the customer is paying "now" for the order update. If payment is "none", then paymentAmount should be zero  */
  settleAmount: z.number(),
  payment: orderPaymentSchema.optional(),
  refund: orderRefundSchema.optional(),
  ignoreExistingReservations: z.boolean().optional(),
  weatherGuarantee: z
    .object({
      quoteId: z.string(),
      status: z.enum(['accept', 'decline']),
      addonId: z.string().uuid()
    })
    .nullable(),
  rideInsurance: z
    .object({
      id: z.string().uuid(),
      planType: z.enum(RideInsuranceConfigSchemas.rideInsurancePlanTypeOptions),
      versionId: z.number()
    })
    .nullable(),
  originalCustomerInvoiceChecksum: z.string().min(1)
})

export type rescheduleCustomerOrder = z.infer<typeof rescheduleCustomerOrderSchema>
